module.exports = __webpack_public_path__ + "static/media/logo-external.cbefd1f0.png";